import { getDecodedSignedFilePath, isSignedFileUrl } from '@commons/utils/fileUtils';

const STORAGE_PATH_PREFIX = '/clients/';

/** Signed (SAS) urls are already escaped by the Azure SDK; only unsigned urls are encoded before reaching invoice-control. */
export const toInvoiceUrl = (link) => {
  if (isSignedFileUrl(link)) {
    return link;
  }

  return encodeURI(link);
};

/**
 * invoice-control echoes S3 urls encoded but returns Azure storage paths already decoded:
 * decoding a storage path again would alter literal '%' sequences in its file name.
 */
export const decodeInvoiceLink = (link) => {
  if (link?.startsWith(STORAGE_PATH_PREFIX)) {
    return link;
  }

  try {
    return decodeURI(link);
  } catch {
    return link;
  }
};

/**
 * invoice-control echoes an S3 url, which matches exactly, and answers with the decoded storage
 * path of an Azure upload, which ends the decoded path of the signed upload url.
 */
export const isSameInvoiceFile = (uploadedLink, invoiceControlListLink) => {
  if (!uploadedLink || !invoiceControlListLink) {
    return false;
  }

  if (uploadedLink === invoiceControlListLink) {
    return true;
  }

  // Unsigned file names may contain '?' or '#': never parse them as urls
  if (!isSignedFileUrl(uploadedLink)) {
    return false;
  }

  if (!invoiceControlListLink.startsWith(STORAGE_PATH_PREFIX)) {
    return false;
  }

  return getDecodedSignedFilePath(uploadedLink).endsWith(invoiceControlListLink);
};
